export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            {
              value: '1_1',
              text: 'достаточно',
            },
            {
              value: '1_2',
              text: 'не в полной мере достаточно',
            },
            {
              value: '1_3',
              text: 'недостаточно',
            },
          ],
          name: '1_element',
          showNumber: true,
          startWithNewLine: false,
          title:
            'На Ваш взгляд, количество конкурсных испытаний для выявления призёров Конкурса-2020:',
          type: 'radiogroup',
        },
        {
          name: '2_element',
          showNumber: true,
          title:
            'Какие конкурсные испытания, по Вашему мнению, были бы наиболее оптимальны и объективны для определения призёров Конкурса?',
          type: 'comment',
        },
        {
          name: '3_element',
          showNumber: true,
          title:
            'Назовите затруднения, с которыми Вам пришлось столкнуться при подготовке и выступлении в конкурсных испытаниях второго тура Конкурса:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '4_1',
              title: 'оптимальны и целесообразны:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '4_2',
              title:
                'соответствуют специфике внеурочной деятельности учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '4_3',
              title: 'позволяют объективно оценить выступление конкурсанта:',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '4_4',
              title: 'другое (укажите, что именно):',
              type: 'comment',
            },
          ],
          name: '4_element',
          showNumber: true,
          title:
            'Насколько, на Ваш взгляд, регламент, формат и организация конкурсного испытания «Классный час» (время, отведенное на общение учителя с обучающимися, дистанционное оценивание членами жюри этапа работы с обучающимися):',
          type: 'panel',
        },
        {
          choices: [
            'высокая степень достаточности, корректности и понятности',
            'средняя степень достаточности, корректности и понятности',
            'низкая степень достаточности, корректности и понятности',
          ],
          name: '5_element',
          showNumber: true,
          hasOther: true,
          title:
            'В какой степени, по Вашему мнению, достаточно, корректно и понятно сформулированы критерии конкурсного испытания «Классный час»?',
          type: 'checkbox',
        },
        {
          choices: [
            'высокая степень достаточности, корректности и понятности',
            'средняя степень достаточности, корректности и понятности',
            'низкая степень достаточности, корректности и понятности',
          ],
          name: '6_element',
          showNumber: true,
          hasOther: true,
          title:
            'В какой степени, по Вашему мнению, достаточно, корректно и понятно сформулированы критерии конкурсного испытания «Мастер-класс»? ',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_1',
              title: 'объективна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_2',
              title:
                'ориентирована на оценку практической деятельности учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'partially',
                  text: 'частично',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_3',
              title: 'отражает современные подходы к оценке деятельности учителя:',
              type: 'radiogroup',
            },
          ],
          name: '7_element',
          showNumber: true,
          title:
            'На Ваш взгляд, система критериев и показателей оценивания конкурсных испытаний второго тура Конкурса (отметьте выбранный ответ):',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_1',
              title: 'оптимально и целесообразно:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_2',
              title:
                'отражает специфику взаимодействия участников образовательных отношений:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '8_3',
              title: 'позволяет объективно оценить выступление конкурсанта:',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '8_4',
              title: 'другое (укажите, что именно):',
              type: 'comment',
            },
          ],
          name: '8_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что оценивание Большим, родительским и ученическим жюри конкурсных испытаний второго тура Конкурса (отметьте выбранный ответ):',
          type: 'panel',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый лауреат Конкурса! Просим Вас выразить свое мнение об организации и проведении Всероссийского конкурса «Учитель года России» 2020 года. Ваши ответы помогут при подготовке и проведении Всероссийского конкурса «Учитель года России» в 2021 году.',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА ЛАУРЕАТА Всероссийского конкурса «Учитель года России» 2020 года',
};
